module.exports = __webpack_public_path__ + "assets/ic_volume_off.svg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/video/ic_volume_off.svg
// module id = 451
// module chunks = 19